import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { useTranslation } from '@/i18n';
import { FC, memo, useCallback, useRef, useState } from 'react';

export type ProxyOffButtonGroupProps = {
  /** Report type id for "Create new" redirect (e.g. payment request 支払依頼). */
  reportTypeId?: string;
};

/** Prevents multiple navigations on double-click. Returns stable handler and whether navigation was triggered. */
function useNavigateOnce(url: string | null) {
  const triggeredRef = useRef(false);
  const [isTriggered, setIsTriggered] = useState(false);
  const handleClick = useCallback(() => {
    if (!url || triggeredRef.current) return;
    triggeredRef.current = true;
    setIsTriggered(true);
    window.location.href = url;
  }, [url]);
  return { handleClick, isTriggered } as const;
}

/** Proxy OFF actions only. Prevents multiple navigations on double-click (NA-4399). */
export const ProxyOffButtonGroup: FC<ProxyOffButtonGroupProps> = memo(
  ({ reportTypeId }) => {
    const { t } = useTranslation();
    const aiOcr = useNavigateOnce('/invoice_upload/new');
    const createNew = useNavigateOnce(
      reportTypeId ? `/report_types/${reportTypeId}/invoice_reports/new` : null
    );

    return (
      <>
        <ButtonV2
          color='primary'
          size='sm'
          isSecondary
          isDisabled={aiOcr.isTriggered}
          data-testid='invoice-reports-proxy-off-ai-ocr-bulk'
          onClick={aiOcr.handleClick}
        >
          {t('invoice_reports.button_groups.ai_ocr_bulk_draft')}
        </ButtonV2>
        <ButtonV2
          color='primary'
          size='sm'
          isSecondary={false}
          isDisabled={!reportTypeId || createNew.isTriggered}
          data-testid='invoice-reports-proxy-off-create-new'
          onClick={createNew.handleClick}
        >
          {t('invoice_reports.button_groups.create_new')}
        </ButtonV2>
      </>
    );
  }
);

ProxyOffButtonGroup.displayName = 'ProxyOffButtonGroup';
